import React from 'react';
import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import {
  WarrantExerciseService,
  type Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseOnBehalfDto,
} from '@wealthlane/api-services/wealthlane-captable-service';
import ToastComponent from '../../components/toast';

interface CalculatePayload extends Wealthlane_CapTable_Dtos_Warrant_CalculateWarrantExerciseOnBehalfDto {
  _rowId: string;
}

const usePostCalculateExerciseOnBehalf = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  newDataRef: React.MutableRefObject<any[]>,
  setNewData: (data: any[]) => void,
  setCalculated: (value: boolean) => void,
  setExerciseResponse: React.Dispatch<React.SetStateAction<any[]>>
): UseMutationResult<any | undefined, unknown, CalculatePayload, unknown> => {
  return useMutation(
    async (payload: CalculatePayload) => {
      const { _rowId, ...apiPayload } = payload;
      const result: any = await handleRequest(
        WarrantExerciseService.postApiCapTableApiAppWarrantExerciseCalculateExerciseOnBehalf(
          apiPayload
        )
      );
      if (result) {
        result._rowId = _rowId;
        result.warrantId = payload.warrantId;
      }
      return result;
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Exercise Calculated.' />);

          const targetRowId = response._rowId;
          const latestData = newDataRef.current;
          const existingIndex = latestData.findIndex((item: any) => item?.id === targetRowId);

          if (existingIndex !== -1) {
            const updatedData = [...latestData];
            updatedData[existingIndex] = {
              ...updatedData[existingIndex],
              netShare: response?.netShares,
              netCash: response?.netCash,
            };
            newDataRef.current = updatedData;
            setNewData(updatedData);
          }

          setCalculated(true);

          setExerciseResponse((prev) => {
            const idx = prev.findIndex((item: any) => item.warrantId === response.warrantId);
            if (idx !== -1) {
              const copy = [...prev];
              copy[idx] = response;
              return copy;
            }
            return [...prev, response];
          });
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCalculateExerciseOnBehalf;
